'use client'

import { createContext, useContext } from 'react'
import { usePathname } from 'next/navigation'
import { CargandoBcm } from '@/components/apps/CargandoBcm'

// La presentacion de cada app (nombre y que hace). Los textos los arma el server
// (lib/apps/intros.js) y los reparte el layout de /apps con <AppIntroProvider>; aca
// solo se dibujan. Por que existe: ver el comentario de lib/apps/intros.js.

const AppIntroContext = createContext(null)

export function AppIntroProvider({ intros, children }) {
  return <AppIntroContext.Provider value={intros || null}>{children}</AppIntroContext.Provider>
}

/**
 * La presentacion de la app de la pagina actual, o null si no tiene (o si la pagina no
 * cuelga del layout de /apps). La app se deduce de la URL: /{idioma}/apps/{carpeta}.
 */
export function useAppIntro() {
  const intros = useContext(AppIntroContext)
  const pathname = usePathname() || ''
  const partes = pathname.split('/')
  const i = partes.indexOf('apps')
  const carpeta = i >= 0 ? partes[i + 1] : null
  return (carpeta && intros?.[carpeta]) || null
}

/**
 * Lo que hay en la pagina mientras la app chequea el acceso o baja su codigo. `children`
 * es el texto de siempre ("Verificando acceso..."): sin presentacion queda solo eso, igual
 * que antes. El color se hereda del contenedor de cada pagina.
 *
 * Lo que se VE es la pantalla de carga de Brian (<CargandoBcm />, el logo que se dibuja
 * letra por letra), que tapa toda la pantalla. La presentacion sigue en el HTML debajo:
 * es lo que lee el que no ejecuta JS (ver lib/apps/intros.js), y el que si lo ejecuta la
 * termina viendo en el cartel de acceso. Como todas las apps pasan por aca, la pantalla
 * de carga es la misma en todas sin tocar cada pagina.
 */
export default function AppIntro({ children }) {
  const intro = useAppIntro()
  if (!intro) {
    return (
      <>
        {children ?? null}
        <CargandoBcm />
      </>
    )
  }

  return (
    <div style={{ maxWidth: 640 }}>
      {intro.nombre ? (
        <h1 style={{ fontSize: 20, fontWeight: 700, lineHeight: 1.3, letterSpacing: 0, margin: '0 0 10px', color: 'inherit' }}>
          {intro.nombre}
        </h1>
      ) : null}
      {intro.parrafos.map((p, i) => (
        <p key={i} style={{ fontSize: 15, lineHeight: 1.6, margin: '0 0 10px', color: 'inherit' }}>
          {p}
        </p>
      ))}
      {children ? <p style={{ fontSize: 14, margin: '14px 0 0', opacity: 0.7, color: 'inherit' }}>{children}</p> : null}
      <CargandoBcm />
    </div>
  )
}
